import { SearchInterface } from "@amzn/ask-legal-domain";
import { Select, SelectProps } from "@amzn/awsui-components-react";
import { Builder } from "builder-pattern";
import * as React from "react";
import { UIModel } from "../../../model/ui-model";
import { withFirstPage } from "./search-filter-utils-v2";

const OPTIONS: SelectProps.Option[] = [
    { label: "Show everything", value: "all" },
    { label: "Show only legal results", value: "true" },
    { label: "Exclude legal results", value: "false" }
];

export const LegalOnlyFilterV2 = (props: {
    queryInputState: UIModel.State<SearchInterface.SearchQueryInput>;
    hasLegalOnlyAccess: boolean;
    disabled?: boolean;
}) => {
    if (!props.hasLegalOnlyAccess) return null;

    const legalOnly = props.queryInputState.value.showStrictlyLegalOnly;
    const selectedValue = legalOnly === true ? "true" : legalOnly === false ? "false" : "all";

    const onChange = (value: string | undefined) => {
        const showStrictlyLegalOnly = value === "true" ? true : value === "false" ? false : undefined;
        props.queryInputState.setValue(withFirstPage(
            Builder<SearchInterface.SearchQueryInput>(props.queryInputState.value)
                .showStrictlyLegalOnly(showStrictlyLegalOnly)
                .build()
        ));
    };

    return (
        <Select
            inlineLabelText="Legal only"
            selectedOption={OPTIONS.find(o => o.value === selectedValue) || OPTIONS[0]}
            options={OPTIONS}
            disabled={props.disabled}
            onChange={({ detail }) => onChange(detail.selectedOption.value)}
            selectedAriaLabel="Selected"
        />
    );
};
